import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import { Link, useParams } from "react-router-dom";
import TableWitthoutPagination from "../../../../components/Common/TableWitthoutPagination";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import {
    loadDeductionSettings as onLoadDeductionSettings,
    loadDeductionSetting as onLoadDeductionSetting,
    loadDeduction as onLoadDeduction,
    getSalaryTypes,
    deleteDeductionSetting as onDeleteDeductionSetting
} from "../../../../slice/payroll/thunks";
import DeleteDeductionSetting from "./DeleteDeductionSetting";
import AddOrEditDeductionSetting from "./AddOrEditDeductionSetting";



const DeductionSettingsList = (props) => {
    const dispatch = useDispatch()
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openAddOrEditModal, setOpenAddOrEditModal] = useState(false);
    const [deductionSettingsToDelete, setDeductionSettingToDelete] = useState(null);

    const { id } = useParams();


    const selectLayoutState = (state) => state.Payroll;
    const PayrollProperties = createSelector(
        selectLayoutState,
        (payroll) => ({
            deductionSettings: payroll?.deductionSettings ?? [],
            deduction: payroll?.deduction ?? {},
            error: payroll?.error ?? null,
            salaryTypes: payroll?.salaryTypes ?? [],
        })
    )

    const { deduction, deductionSettings, error, salaryTypes } = useSelector(PayrollProperties)
    const [deductionSettingToEdit, setDeductionSettingToEdit] = useState(null);

    const loadDeductionSettings = useCallback(() => {
        dispatch(onLoadDeductionSettings(id))
    }, [dispatch, id]);

    const loadDeduction = useCallback(() => {
        dispatch(onLoadDeduction(id))
    }, [dispatch, id]);

    const handleDeleteClickEvent = useCallback((row) => {
        setDeductionSettingToDelete(row);
        setOpenDeleteModal(true);
    }, [setOpenDeleteModal, setDeductionSettingToDelete]);

    const handleEditClick = useCallback((row) => {
        setDeductionSettingToEdit(row);
        setOpenAddOrEditModal(true);
    }, []);

    const fermerModal = useCallback(() => {
        setOpenDeleteModal(false);
    }, [setOpenDeleteModal]);

    const AddOrEditCloseModal = useCallback(() => {
        setOpenAddOrEditModal(false);
    }, [setOpenAddOrEditModal])

    const handleToggle = () => {
        setOpenDeleteModal(!openDeleteModal);
    }

    const handleAddOrEditToggle = () => {
        setOpenAddOrEditModal(true);
    }

    const confirmDelete = useCallback(() => {
        if (!deductionSettingsToDelete) return;
        dispatch(onDeleteDeductionSetting({
            deductionId: deductionSettingsToDelete.deductionId,
            id: deductionSettingsToDelete.id
        }))
            .unwrap()
            .then(() => {
                setDeductionSettingToDelete(null);
                setOpenDeleteModal(false);
                loadDeductionSettings();
            })
    }, [dispatch, deductionSettingsToDelete, loadDeductionSettings])

    useEffect(() => {
        loadDeduction()
        loadDeductionSettings();
        dispatch(getSalaryTypes());
    }, [dispatch])

    const columns = useMemo(() => [
        {
            id: 'rank',
            header: 'Rank',
            accessorKey: "rank",
        },
        {
            id: 'salary-min',
            header: 'Salary Min',
            accessorKey: "salaryMin",
        },
        {
            id: 'salary-max',
            header: 'Salary Max',
            accessorKey: "salaryMax",
        },
        {
            id: 'rate-amount',
            header: 'Rate / Amount',
            cell: (cellProp) => {
                return (
                    <>
                        {cellProp.row.original.percentage ? cellProp.row.original.rateOrAmount + ' %' : cellProp.row.original.rateOrAmount}
                    </>
                )
            }
        },
        {
            id: 'amount-to-consider',
            header: 'Amount to consider',
            cell: (cellProp) => {
                return (
                    <>
                        {cellProp.row.original.amountToConsider ? cellProp.row.original.amountToConsider : (salaryTypes?.find((salaryType) => salaryType.value === deduction.appliedTo)?.title || "--------")}
                    </>
                )
            },
        },
        {
            id: 'actions',
            header: 'Actions',
            cell: (cellProp) => {
                return (
                    <>
                        <div className="text-center">
                            <Link onClick={() => handleEditClick(cellProp.row.original)} type="button">
                                <i className="fa-solid fa-pencil"></i>
                            </Link>
                            <Link type="button" onClick={() => handleDeleteClickEvent(cellProp.row.original)}>
                                <i className="ms-1 fa-solid fa-trash"></i>
                            </Link>
                        </div>
                    </>
                );
            }
        },
    ]);

    return (
        <div className="setting-zone-screen-13-2-sec">
            <div className="container">
                <div className="id g-4 pt-4 px-4 mb-3">
                    <div className="head d-flex">
                        <h6>Deduction : {deduction?.name ?? ''}</h6>
                    </div>
                    <div className="setting-zone-screen-13-2 d-flex" style={{ "height:": "fit-content" }}>
                        <div className="zone-13-2-sec d-flex">
                            <div className="col d-flex">
                                <div className="arrow-left">
                                    <Link to={"/payroll/deductions"}>
                                        <img className="img-fluid" alt="return" src="../../../assets/images/patient-details/arrow-left.png" />
                                    </Link>
                                </div>
                                <div className="heading align-middle">
                                    <p className="mb-0">Back to Deductions List</p>
                                </div>
                            </div>

                            <div className="col d-flex justify-content-end text-end">
                                <button className="btn btn-std mx-2" onClick={() => handleAddOrEditToggle()}>
                                    New config
                                </button>
                            </div>
                        </div>
                        <TableWitthoutPagination
                            columns={columns}
                            data={deductionSettings}
                        />

                        <DeleteDeductionSetting
                            open={openDeleteModal}
                            handleToggle={handleToggle}
                            clickActionCallback={confirmDelete}
                            fermerModal={fermerModal}
                        />
                        <AddOrEditDeductionSetting
                            openModal={openAddOrEditModal}
                            handleToggle={handleAddOrEditToggle}
                            AddOrEditCloseModal={AddOrEditCloseModal}
                            deductionSetting={deductionSettingToEdit}
                            deductionId={id}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default withRouter(withTranslation()(DeductionSettingsList))